import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/site/Hero";
import Legacy from "../components/site/Legacy";
import ImpactStats from "../components/site/ImpactStats";
import SectorGrid from "../components/site/SectorGrid";
import GovernanceStrategy from "../components/site/GovernanceStrategy";
import DigitalBharatCommand from "../components/site/DigitalBharatCommand";
import ThoughtLeadership from "../components/site/ThoughtLeadership";
import ContactForm from "../components/site/ContactForm";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const el = document.getElementById(target);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          80
        );
      }
    }
  }, [location.state]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Legacy />
      <ImpactStats />
      <SectorGrid />
      <GovernanceStrategy />
      <DigitalBharatCommand />
      <ThoughtLeadership />
      <ContactForm />
    </main>
  );
}
